import { Avatar, styled } from '@mui/material'
import { useProjectPrivateContext } from '../../context/projectContext'
import { colorPalette } from '../../style/colorPalette'
import { intl } from '../../../i18n'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { PageArea } from '../index'

const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
})

const ProjectIcon = styled(Avatar)({
  height: '64px',
  width: '64px',
  border: `solid ${colorPalette.monotone[2]} 1px`,
  marginBottom: '16px',
})

const WelcomeText = styled('div')({
  fontSize: '24px',
  fontWeight: '600',
  lineHeight: '36px',
  textAlign: 'center',
  color: colorPalette.monotone[4],
  whiteSpace: 'pre-line',
  padding: '10px',
})

export const ProjectTop = projectPrivate(() => {
  const { project } = useProjectPrivateContext()

  return (
    <PageArea>
      <Content>
        {project.iconUrl && (
          <ProjectIcon variant="rounded" src={project.iconUrl} />
        )}
        <WelcomeText>
          {intl.formatMessage(
            { id: 'projectTop.welcome' },
            { projectName: project.displayName }
          )}
        </WelcomeText>
      </Content>
    </PageArea>
  )
})
